module.exports = __webpack_public_path__ + "img/t5-i8.2ddaae67.svg";